module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('headerpage', {
    attrs: {
      "status": 0
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "deground"
  }, [_c('div', {
    staticClass: "adaptation",
    staticStyle: {
      "background-color": "#f6f8f7"
    }
  }, [_c('div', {
    staticClass: "hetext"
  }, [_vm._v("首页>" + _vm._s(_vm.type == 1 ? '园区通知' : '园区要闻'))]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('el-tabs', {
    staticClass: "box_cet tab-pane1",
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, _vm._l((_vm.tablist), function(item, index) {
    return _c('el-tab-pane', {
      staticClass: "xia",
      attrs: {
        "label": item.name,
        "name": String(index)
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('div', {
    staticClass: "box1_cent tablecss"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "title",
      "label": "标题",
      "width": "700px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cat_name",
      "label": "类型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "realse_time",
      "label": "发布时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.type == 1) ? [_c('div', {
          staticClass: "detaii",
          on: {
            "click": function($event) {
              return _vm.detailchange('detail', scope.row.id, 3)
            }
          }
        }, [_vm._v("查看详情")])] : [_c('div', {
          staticClass: "detaii",
          on: {
            "click": function($event) {
              return _vm.detailchange('detail', scope.row.id, 4)
            }
          }
        }, [_vm._v("查看详情")])]]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "box1_fot pagecss"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "page-size": _vm.pagesize,
      "hide-on-single-page": true,
      "layout": "prev, pager, next",
      "current-page": _vm.currentPage,
      "total": _vm.totalnum
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fcfb5d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/listpage.vue
// module id = 894
// module chunks = 1